module.exports = __webpack_public_path__ + "img/1586572430.d2799260.jpg";